<template>
  <div id="mdPrintId" style="width: 265px; opacity: 0">
    <el-row>
      <el-col v-if="printData.length > 0">
        <div
          v-for="list in printData"
          :key="list"
          style="page-break-after: always"
        >
          <div
            v-if="list.space || list.position"
            style="
              border-bottom: 1px solid;
              margin-bottom: 0;
              padding: 10px 0;
              font-size: 24px;
              font-weight: 800;
              width: 100%;
            "
          >
            <div style="width: 60%; display: inline-block">
              {{ list.space }}&nbsp;
            </div>
            <div style="text-align: right; width: 36%; display: inline-block">
              {{ list.position }}
            </div>
          </div>
          <div style="margin-bottom: 0; width: 100%">
            <div style="font-size: 24px">{{ list.consignee }}</div>
            <div style="font-size: 16px; margin-top: 4px">
              收货地址：{{ list.address }}
            </div>
            <!--<div style="font-size: 16px;margin-top: 4px;">打印时间：{{resData.print_time}}</div>-->
          </div>
          <div style="border: 0.5px solid; width: 100%"></div>

          <div style="margin-bottom: 0; width: 100%">
            <img
              style="width: 265px; margin-top: 20px; margin-bottom: 10px"
              :src="
                'https://erp.yishouapp.com/barcode.php?text=' +
                  list.wave_picking_no
              "
            />
          </div>
          <div style="text-align: center; font-weight: bold">
            快递公司:{{ list.shipping_company }}
          </div>
          <div
            style="
              border: 0.5px solid;
              width: 100%;
              font-size: 20px;
              padding-top: 0px;
            "
          ></div>

          <!--商品信息-->
          <div
            v-for="goods in list.goods_info"
            :key="goods"
            style="margin-bottom: 0; width: 100%"
          >
            <div
              style="
                font-size: 24px;
                margin-top: 5px;
                margin-bottom: 5px;
                font-weight: bold;
              "
            >
              <span style="font-weight: normal">{{ goods.goods_no }}</span>
              <span style="float: right">{{ goods.goods_location }}</span>
            </div>
            <div
              style="
                font-size: 22px;
                margin-top: 5px;
                margin-bottom: 5px;
                font-weight: bold;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-weight: normal;
                  float: left;
                  border: black solid 1px;
                  border-radius: 100%;
                  padding: 0px 4px;
                "
                >{{ goods.no }}</span
              >
              <div v-for="sku in goods.sku" :key="sku">
                <div style="display: inline-block; float: right">
                  {{ sku }}
                </div>
                <div style="clear: both"></div>
              </div>
            </div>
            <div style="font-size: 16px; margin-top: 5px; margin-bottom: 5px">
              <span>{{ goods.goods_name }}</span>
            </div>
            <div style="border: 1px dotted; width: 100%"></div>
          </div>

          <div style="margin-bottom: 0; width: 100%">
            <div
              style="
                font-size: 24px;
                text-align: center;
                margin-top: 5px;
                margin-bottom: 5px;
              "
            >
              共{{ list.spu_num }}款，{{ list.sku_num }}件
            </div>
          </div>
          <div
            style="border: 2px dotted; width: 100%; margin-bottom: 20px"
          ></div>

          <!--订单信息-->

          <div
            v-for="order in list.order_info"
            :key="order"
            style="margin-bottom: 0; width: 100%"
          >
            <div style="font-size: 16px; margin-top: 5px; margin-bottom: 5px">
              <span
                style="
                  font-size: 12px;
                  border: black solid 1px;
                  border-radius: 100%;
                  padding: 0px 4px;
                "
                >{{ order.order_no }}</span
              >
              <span v-if="type == 4">工单id：{{ order.work_id }}</span>
              <span v-if="type != 4">订单号：{{ order.order_sn }}</span>
              <div
                v-if="order.problem_name && type >= 4"
                style="font-size: 18px; font-weight: bold"
              >
                工单问题：{{ order.problem_name }}
              </div>
              <div
                v-if="order.problem_desc && type >= 4"
                style="font-size: 18px; font-weight: bold"
              >
                工单描述：{{ order.problem_desc }}
              </div>
            </div>
          </div>
          <div style="border: 0.5px solid; width: 100%"></div>

          <!--<div style="margin-top: 5px;margin-bottom: 40px;width:100%;border: 0.5px solid;">-->
          <!--<span style="padding: 20px 20px 20px 20px;">亲亲，如商品有错/漏/破等质量问题，请您务必在3天内联系客服小姐姐哦，否则会影响您的售后服务呢！</span>-->
          <!--</div>-->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import getLodop from "../assets/js/LodopFuncs";
export default {
  props: {
    printData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: Number,
      default: 0,
    },
    isPrint: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    setTimeout(() => {
      console.log("开始lodop打印");
      this.lodopPrint();
    }, 500);
  },
  methods: {
    lodopPrint() {
      try {
        let ele = document.getElementById("mdPrintId");
        let html = ele.innerHTML;
        this.$emit("PrintClose", true);
        let h = ele.offsetHeight;
        h = h / 3.78 + "mm";
        let LODOP = getLodop(); //调用getLodop获取LODOP对象
        LODOP.PRINT_INIT("");
        //添加license
        LODOP.SET_LICENSES(
          "广州富米科技有限公司",
          "A564177D3271E3CFF371162E393C53F6AE2",
          "廣州富米科技有限公司",
          "750CF994CE8CD4FE765C2B772159BF47828",
        );
        LODOP.SET_LICENSES(
          "THIRD LICENSE",
          "",
          "Guangzhou Fumi Technology Co., Ltd.",
          "CA02B8F057FF195E4C65561D1AD6492A379",
        );
        let re = LODOP.SET_PRINTER_INDEX("phd");
        console.log(LODOP.SET_PRINTER_INDEX);
        if (re) {
          LODOP.SET_PRINT_PAGESIZE(1, "80mm", h, "");
          LODOP.ADD_PRINT_HTM("1mm", "1mm", "70mm", h, html);
          if (this.isPrint) {
            LODOP.PRINT();
          } else {
            LODOP.PREVIEW();
          }
        } else {
          this.$message.error("打印机设置失败");
        }
      } catch (e) {
        this.$emit("PrintClose", true);
        console.log("配货单打印错误");
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LodopPrintForCheck.vue